// Email-header logo dimensions are SEPARATE from the document-header logo
// dimensions in `branding.ts`. The email layout slot renders the logo at 38px
// height in a 50px-wide column (templates/base-layout-broker-ai.mjml), so a
// roughly-square mark is the right shape — not the 1200x250 letterhead used
// for DOCX outputs. Matches the existing terraform-managed broker-ai logo
// (asserted at 400x400 in legal-ai-backend test/contracts/broker-ai-email-logo.test.ts).
export const EMAIL_BRANDING_IMAGE_DIMENSIONS = {
  width: 400,
  height: 400,
} as const;

export const EMAIL_BRANDING_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
